import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IsAdminGuard, AutoLoginGuard } from 'projects/lib_authentication/src/public-api';
import { CodeReceiveComponent } from './components/code-receive/code-receive.component';
import { CookieNoticeComponent } from './components/cookie-notice/cookie-notice.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { NoAccessToFeatureComponent } from './components/no-access-to-feature/no-access-to-feature.component';
import { OssCopyrightComponent } from './components/oss-copyright/oss-copyright.component';
import { PrivacyStatementComponent } from './components/privacy-statement/privacy-statement.component';
import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';

const routes: Routes = [
  {
    path: "code-receive",
    data: { breadcrumb: "Authorization", section: 'Authorization', title: 'Code Recieve' },
    component: CodeReceiveComponent
  },
  {
    path: '',
    canActivate: [AutoLoginGuard],
    children: [
      {
        path: '',
        children: [
          {
            path: 'company-structure',
            loadChildren: () => import('projects/app_company-structure/src/app/app.module').then(m => m.CompanyManagementModule),
          },
          {
            path: 'submissions',
            loadChildren: () => import('projects/app_submissions/src/app/app.module').then(m => m.SubmissionsModule),
          },
          {
            path: 'workflows',
            data: { breadcrumb: "Workflows" },
            loadChildren: () => import('projects/app_workflows/src/app/app.module').then(m => m.WorkflowsModule),
          },
          {
            path: 'client-access-management',
            data: { breadcrumb: "Client access management" },
            loadChildren: () => import('projects/app_client-access-management/src/app/app.module').then(m => m.ClientAccessManagementModule),
          },
          {
            path: 'administration',
            data: { breadcrumb: "Administration" },
            canActivate: [IsAdminGuard],
            loadChildren: () => import('projects/app_administration/src/app/app.module').then(m => m.AdministrationModule),
          },
          {
            path: 'terms-of-use',
            data: { breadcrumb: "Terms of use", section: 'Terms of use', title: 'Terms of use' },
            component: TermsOfUseComponent
          },
          {
            path: 'privacy',
            data: { breadcrumb: "Privacy Statement", section: 'Privacy Statement', title: 'Privacy Statement' },
            component: PrivacyStatementComponent
          },
          {
            path: 'oss-copyright',
            data: { breadcrumb: "OSS Copyright", section: 'OSS Copyright', title: 'OSS Copyright' },
            component: OssCopyrightComponent
          },
          {
            path: 'no-access-to-feature',
            data: { breadcrumb: "No access" },
            component: NoAccessToFeatureComponent,
            pathMatch: 'full'
          },
          {
            path: 'cookie-notice',
            data: { breadcrumb: "Cookie notice", section: 'Cookie notice', title: 'Cookie notice' },
            component: CookieNoticeComponent
          },
          {
            path: 'home',
            data: { breadcrumb: "Home", section: 'Home', title: 'Home' },
            component: HomePageComponent
          },
          {
            path: '**',
            redirectTo: 'home',
            pathMatch: 'full'
          }
        ]
      }

    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
